import type { ComponentPropsWithRef, JSX } from "react";
import { cx } from "../cx";

export type IconButtonVariant = "ghost" | "primary";
export type IconButtonSize = "sm" | "md" | "lg";

export interface IconButtonProps extends ComponentPropsWithRef<"button"> {
  /** Accessible name (required). */
  label: string;
  /** Square edge: sm 28 / md 36 / lg 44px. */
  size?: IconButtonSize | undefined;
  variant?: IconButtonVariant | undefined;
}

/**
 * Square icon-only button for toolbars and headers. Pass the icon as
 * children (16-20px, stroke currentColor) and always set `label`.
 * Ported from design/tarski-kit/components/actions/IconButton.jsx.
 */
export function IconButton({
  label,
  size = "md",
  variant = "ghost",
  type = "button",
  className,
  children,
  ...rest
}: IconButtonProps): JSX.Element {
  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={cx(
        "tk-icon-button",
        `tk-icon-button--${variant}`,
        `tk-icon-button--${size}`,
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
